import { use, type ResourceLanguage } from "i18next";
import { initReactI18next } from "react-i18next";
import { ru } from "./translations/ru";
import { en } from "./translations/en";
import { LANGUAGE_STORAGE_KEY } from "@ai/uimain/src/constants/localStorageKeys";

export type Language = "en" | "ru";

export const FALLBACK_LANGUAGE = "ru";

const resources: Record<Language, ResourceLanguage> = {
  en: { translation: en },
  ru: { translation: ru },
};

void use(initReactI18next).init({
  fallbackLng: localStorage.getItem(LANGUAGE_STORAGE_KEY) || FALLBACK_LANGUAGE,
  resources,
});
